import { Paper } from "@mui/material";
import React from "react";
import Carousel from "react-material-ui-carousel";
import img1 from "../../assets/journey/roof1.jpg";
import img2 from "../../assets/journey/roof2.jpg";
import img3 from "../../assets/journey/class1.jpg";
import img4 from "../../assets/journey/class2.jpg";
import ooklassCoaching from "../../assets/journey/ooklass-img.jpg"
import ooklass_p3 from "../../assets/journey/ooklass-p3.jpg"
import ooklass_p4 from "../../assets/journey/ooklass-p4.jpg"
import ooklass_p1 from "../../assets/journey/ooklass-p1.jpg"

const JourneyCarousel = () => {
  const images = [
    {
      url: img1,
      alt: "Image 1",
    },
    {
      url: img2,
      alt: "Image 2",
    },
    {
      url: img3,
      alt: "Image 3",
    },
    {
      url: img4,
      alt: "Image 4",
    },
    {
      url: ooklassCoaching,
      alt: "Image 4",
    },
    {
      url: ooklass_p3,
      alt: "Image 4",
    },
    {
      url: ooklass_p4,
      alt: "Image 4",
    },
    {
      url: ooklass_p1,
      alt: "Image 4",
    }

  ];

  const carouselItems = images.map((image) => (
    <Paper key={image.alt}>
      <img
        className="img-fluid d-block w-100"
        src={image.url}
        alt={image.alt}
      />
    </Paper>
  ));

  return (
    <>
      <div className="container section-bg my-5">
        <div className="row">
          <div className="col-md-6">
            <div className="p-5">
              <h1 className="text-cneter orange-text fw-bolder mx-auto mb-2 mt-4">
                Our Story
              </h1>
              <h3 className="text-cneter blue-text fw-bolder">
                From a Dream to Reality
              </h3>
              <p>
                Our story began with a passionate educator and a bunch of dedicated
                students, gathering on the rooftop of a house for the first
                tuition session. From that moment on, we dedicated ourselves to
                delivering the best education possible to our students.
              </p>
              <p>
                As our reputation for quality education grew, we expanded to a
                single classroom and then to a two-classroom setup. Along the
                way, we helped many students achieve their academic goals,
                empowering them to reach their full potential and pursue their
                passions.
              </p>
              <p>
                We are proud of the progress our students have made over the
                years, and we continue to be dedicated to providing personalized
                and effective education to all of our students. Today, we stand at a dream come true. 
                We now have our very own building, a space we can proudly call home. With three fully 
                air-conditioned classrooms, each accommodating up to 40 students, 
                we’ve created an environment where learning can truly thrive. 
                Every detail has been designed to help our students focus and study better, 
                providing them with the comfort and atmosphere they need to excel.
              </p>
              <p>
               This journey has been filled with hard work, sleepless nights,
               and unwavering belief in our students. We are beyond grateful 
               to everyone who has been part of our story—our students, our teachers, 
               and our supporters. Together, we've turned a dream into reality, and with your continued support,
               we are excited for the even greater milestones that lie ahead. 
              </p>
            </div>
          </div>
          <div className="col-md-5 p-5 my-auto mx-auto bg-light border rounded">
            <div className="journey-carousel">
              <Carousel>{carouselItems}</Carousel>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default JourneyCarousel;
